import type { ComponentType } from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, type SvgIcon, type SvgIconProps } from "@mui/material";
import ArrowIcon from "@components/general/ArrowIcon/ArrowIcon";

interface OutlinedContainerEndAdornmentProps {
  open: boolean;
  className?: string;
  Icon?: typeof SvgIcon | ComponentType<SvgIconProps>;
  clearable?: boolean;
  onClear?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const OutlinedContainerEndAdornment = ({
  open,
  className,
  Icon = ArrowRightIcon,
  clearable,
  onClear,
}: OutlinedContainerEndAdornmentProps) => {
  return (
    <div className={className}>
      {clearable && onClear && (
        <IconButton
          size="small"
          sx={{ p: 0.2 }}
          onClick={onClear}
          className="hover:bg-grey-900 opacity-0 group-hover:opacity-100"
          aria-label="clear input"
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
      <IconButton size="small" sx={{ p: 0.2 }}>
        <ArrowIcon down={!open} up={open} size={20} Icon={Icon} />
      </IconButton>
    </div>
  );
};
